/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The request body for exporting mailing labels
 */
export type ExportMailingLabelsRequest = {
    /**
     * The group
     */
    group?: ExportMailingLabelsRequest.group;
    /**
     * The family name format
     */
    family_name_format?: ExportMailingLabelsRequest.family_name_format;
    /**
     * Show all members
     */
    show_all_members?: boolean;
    /**
     * The template ID
     */
    template_id?: number;
    /**
     * The order by field
     */
    order_by?: string;
    /**
     * The all selected field
     */
    allSelected?: boolean;
    /**
     * Hide private data
     */
    hide_private_data?: boolean;
    /**
     * Show labels
     */
    show_labels?: boolean;
    /**
     * The filters
     */
    filters?: {
        /**
         * Archived exists filter
         */
        'archived:exists'?: boolean;
        /**
         * Email default filter
         */
        'or:emailDefault'?: string;
        /**
         * Phone default filter
         */
        'or:phoneDefault'?: string;
    };
    /**
     * Selected fields
     */
    selected_fields?: Array<{
        /**
         * The type of the selected field
         */
        type?: string;
    }>;
    /**
     * Mailing label template
     */
    mailing_labels_template?: string;
    /**
     * Customized Mailing label templates
     */
    customize_mailing_labels_template?: Array<{
        /**
         * Mailing label template for an individual
         */
        individual?: string;
        /**
         * Mailing label template for a couple or parents
         */
        adults?: string;
        /**
         * Mailing label template for one adult family
         */
        adult?: string;
    }>;
};

export namespace ExportMailingLabelsRequest {

    /**
     * The group
     */
    export enum group {
        INDIVIDUALS = 'individuals',
        ENTIRE_FAMILY = 'entire_family',
        LIST_FAMILY = 'list_family',
    }

    /**
     * The family name format
     */
    export enum family_name_format {
        ADULTS = 'Adults',
        ADULTS_AND_CHILDREN = 'Adults and Children',
        FAMILY_NAME = 'Family Name',
        FORMAL_FAMILY_NAME = 'Formal Family Name',
    }


}

